import React from 'react';
import styled from 'styled-components';
import {
    space,
    layout,
    grid,
    GridProps,
    LayoutProps,
    SpaceProps,
} from 'styled-system';
import { getValueAndUnit, rem } from 'polished';
import Box from '../Box/Box';

type StyledGridProps = GridProps & LayoutProps & SpaceProps;

const StyledGrid = styled(Box)<StyledGridProps>`
    display: grid;
    width: 100%;
    ${grid}
    ${layout}
    ${space}
`;

const gridMaxWidth = 1460;
export const gridInlinePadding = { _: '16px', md: '32px', lg: '64px' };

export const gridGap = {
    _: '8px',
    md: '16px',
    lg: '24px',
    xl: '16px',
    '2xl': '28px',
};

const Grid = ({ children, ...props }) => (
    <StyledGrid
        gridTemplateColumns={{
            _: 'repeat(4, 1fr)',
            sm: 'repeat(8, 1fr)',
            lg: 'repeat(12, 1fr)',
        }}
        gridColumnGap={gridGap}
        px={gridInlinePadding}
        maxWidth={{
            _: rem(gridMaxWidth + getValueAndUnit(gridInlinePadding._)[0] * 2),
            md: rem(
                gridMaxWidth + getValueAndUnit(gridInlinePadding.md)[0] * 2
            ),
            lg: rem(
                gridMaxWidth + getValueAndUnit(gridInlinePadding.lg)[0] * 2
            ),
        }}
        mx="auto"
        {...props}
    >
        {' '}
        {children}
    </StyledGrid>
);

export default Grid;
